export default __webpack_public_path__ + "static/tag-do-3-dark-a22522aab731c27d362e40e109a20952e7bdfe904278d8e63e07db5b04f2a5e2.png";